window.dt_pabean_report_goods_releases = (elm) => {
  const $table = $(elm).closest('div').find('table');
  const uid = $(elm).closest('.tab-pane').attr('uid');

  if ($table.length) {
    window.dt_init[uid] = $table.DataTable({
      serverSide: true,
      processing: false,
      responsive: true,
      ajax: {
        url: dtGetUrl($table),
        data: function (d) {
          d.bc = $(`#${uid}bc`).val();
          d.begin_date = $(`#${uid}begin_date`).val();
          d.end_date = $(`#${uid}end_date`).val();
        },
        type: 'GET',
        beforeSend: function () { dtShowLoading($table); },
        complete: function () {
          dtHideLoading($table);
        }
      },
      columns: [
        { data: 'index' },
        { data: 'pabean_code' },
        { data: 'pabean_number' },
        { data: 'pabean_date' },
        { data: 'evidence_number' },
        { data: 'evidence_date' },
        { data: 'entity' },
        { data: 'product_code' },
        { data: 'product_name' },
        { data: 'qty' },
        { data: 'unit' },
        { data: 'value' },
      ],
      columnDefs: [
        {
          targets: -1,
          className: 'text-end'
        },
        {
          targets: 8,
          className: 'text-nowrap'
        }
      ],
      pagingType: 'numbers',
      language: {
        search: ' ',
        lengthMenu: '_MENU_',
        searchPlaceholder: "Search...",
        info: "Showing _START_ to _END_ of _TOTAL_ entries"
      },
      buttons: [],
      pageLength: 10,
      sDom: 'fBtlpi',
      lengthMenu: [[10, 50, 100, 500, 1000, -1], [10, 50, 100, 500, 1000, "All"]]
    });
    dtFinalTouch($table);
  }

  $(document).off('click', `#${uid}btn-filter`)
  $(document).on('click', `#${uid}btn-filter`, function() {
    if($(`#${uid}begin_date`).val() == '') {
      $(`#${uid}begin_date`).focus()
      alert('Tanggal awal harus diisi')
      return
    }

    if($(`#${uid}end_date`).val() == '') {
      $(`#${uid}end_date`).focus()
      alert('Tanggal akhir harus diisi')
      return
    }

    window.dt_init[uid].ajax.reload()
  })
}
